import {QuantityConfiguration} from '../../../fields/quantity/types'
import {getTruckSize, isMultipleTruck} from '../../../fields/trucks/trucks.utils'
import {TruckConfiguration, TruckForm} from '../../../fields/trucks/types'
import {CreateFormInput} from '../types'

export const buildTruckForm = ({
  configuration
}: CreateFormInput<TruckConfiguration & QuantityConfiguration>): TruckForm => {
  const truckType = configuration.trucks.isEnabled
    ? configuration.trucks.truckTypes.default
    : undefined
  const truckSize = getTruckSize(configuration.trucks, truckType)

  return {
    truckType: truckType,
    isMultipleTruck: isMultipleTruck(
      configuration.quantity.default ?? configuration.quantity.min,
      truckSize
    )
  }
}
